import React from 'react';
import { List, Datagrid, TextField, CreateButton, TopToolbar, useRecordContext } from 'react-admin';

// Function to format seconds to time format (MM:SS or HH:MM:SS)
const formatDuration = (seconds: number | string | null | undefined): string => {
  if (!seconds && seconds !== 0) {
    return '-';
  }
  
  const totalSeconds = typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
  
  if (isNaN(totalSeconds) || totalSeconds < 0) {
    return '-';
  }
  
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  
  if (hours > 0) {
    // Format: HH:MM:SS
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  } else {
    // Format: MM:SS
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  }
};

const DurationField = ({ source, label }: { source: string; label?: string }) => {
  const record = useRecordContext();
  const duration = record?.[source];
  const formatted = formatDuration(duration);
  
  return (
    <TextField 
      source={source} 
      label={label || 'Duration'}
      record={{ ...record, [source]: formatted }}
    />
  );
};

const ContentListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export const ContentList = () => (
  <List 
    actions={<ContentListActions />}
    empty={
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ marginBottom: '20px' }}>No audio content</div>
        <CreateButton />
      </div>
    }
  >
    <Datagrid>
      <TextField source="title" label="Name" />
      <TextField source="category_name" label="Category" />
      <TextField source="type" label="Type" />
      <DurationField source="duration_seconds" label="Duration" />
    </Datagrid>
  </List>
);

